var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * This module provides composable functions for working with different types (views) of history objects.
 * Containing different amounts of required information about a history object depending on the use case.
 */
import { computed, onMounted } from "vue";
import { useHistoryStore } from "@/stores/historyStore";
/**
 * Provides the extended details for a history.
 * This composable should be used when the extended details are required.
 * The extended details usually include the size of the history and the number of active, deleted, and hidden items.
 * @param historyId The id of the history to get the extended details for.
 */
export function useExtendedHistory(historyId) {
    const historyStore = useHistoryStore();
    onMounted(() => __awaiter(this, void 0, void 0, function* () {
        // Make sure the history is loaded with the extended details
        // as it may not have been loaded yet or may not have the extended details.
        yield historyStore.loadHistoryById(historyId);
    }));
    const history = computed(() => historyStore.getHistoryById(historyId));
    return {
        history,
    };
}
